<template>
  <div>
    <DashboardHeader title="Payment Successful">
      <v-layout row wrap>
        <v-flex xs12 md12>
          <Loader></Loader>
        </v-flex>
      </v-layout>
      <v-row>
        <v-flex class="mx-auto mt-10" xs12 md8>
          <v-card class="mx-auto mt-10" elevation="12">
            <v-img class="mt-4 mb-14 mx-10" :src="getApiUrl+'/images/bitspay/payfast_trans.png'"></v-img>
            <v-row>
              <v-alert class="mx-auto" :type="typeColor" width="90%">
                <v-row>
                  <h1 class="mx-auto">{{msg}}</h1>
                  <br />
                </v-row>
              </v-alert>
            </v-row>
            <v-row v-if="view">
              <v-btn class="mx-auto mt-10" width="90%" color="blue" dark @click="viewReceipt()">
                <v-icon left>mdi-receipt</v-icon>View Payment Receipt
              </v-btn>
            </v-row>

            <v-row>
              <v-btn
                @click="goBack()"
                class="mx-auto my-10"
                width="90%"
                :color="getThemeColor"
                dark
              >
                <v-icon left>mdi-apps</v-icon>Go Back To Switchboard
              </v-btn>
            </v-row>
          </v-card>
        </v-flex>
      </v-row>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import Loader from "@/components/Loader.vue";
import axios from "@/plugins/axios";

export default {
  beforeRouteEnter(to, from, next) {
    if (from.path == "/payments-receipt") {
      next("/switchboard");
    } else {
      next();
    }
  },
  components: { DashboardHeader, Loader },

  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },

  mounted() {
    this.$store.commit("setLoader", true);

    if (
      this.$route.query.token != undefined &&
      this.$route.query.token != null
    ) {
      this.token = this.$route.query.token;
      axios
        .postDataWithToken(
          "/auth/retrieve-payment-details",
          { token: this.token },
          this.getAccessToken
        )
        .then(paymentInfo => {
          if (paymentInfo.status == 500 || paymentInfo == "error") {
            this.msg = "No Payment Data Found!";
            this.typeColor = "error";
            this.view = false;
            this.$store.commit("setLoader", false);
            return;
          }
          this.view = true;
          this.getPaymentInfo = paymentInfo;
          const curDate = axios.getCurrentDate();
          let description = null;
          let descriptionId = null;
          if (paymentInfo != null && paymentInfo.selectedCat != null) {
            this.student = paymentInfo.student;
            this.studentFinance = paymentInfo.studentFinance;
            descriptionId = paymentInfo.selectedCat.split("|")[0];
            description = paymentInfo.selectedCat.split("|")[1];

            axios
              .postDataWithToken(
                "/auth/save-online-payment-info",
                {
                  sid: paymentInfo.sid,
                  emis: paymentInfo.emis,
                  date: curDate,
                  amount: paymentInfo.amount,
                  fbInfo: paymentInfo.fbInfo,
                  token: this.token,
                  descriptionId,
                  description
                },
                this.getAccessToken
              )
              .then(response => {
                this.$store.commit("setLoader", false);
                this.payment = response;
              });
          } else {
            this.$store.commit("setLoader", false);
          }
        });
    }
  },
  methods: {
    viewReceipt() {
      this.$router.push({
        name: "payments-receipt",
        params: {
          student: this.student,
          studentFinance: this.studentFinance,
          payment: this.payment
        }
      });
    },
    goBack() {
      this.$router.push({ name: "switchboard" });
    }
  },
  data() {
    return {
      token: null,
      msg: "Payment Successful!",
      typeColor: "success",
      success: false,
      student: null,
      studentFinance: null,
      payment: null,
      getPaymentInfo: null,
      view: false
    };
  }
};
</script>

<style>
</style>